import type { SelectionState } from '../../features/booking/selectionSlice'

export const STEP_IDS = ['location', 'services', 'specialist', 'time', 'details', 'done'] as const

export type StepId = (typeof STEP_IDS)[number]

export const STEP_TITLES: Record<StepId, string> = {
  location: 'Location',
  services: 'Services',
  specialist: 'Specialist',
  time: 'Date & time',
  details: 'Your details',
  done: 'Confirmation',
}

export function isStepId(value: string | undefined): value is StepId {
  return !!value && (STEP_IDS as readonly string[]).includes(value)
}

export function stepIndex(step: StepId): number {
  return STEP_IDS.indexOf(step)
}

/**
 * The first step whose prerequisite is missing. Guarding by "first incomplete"
 * rather than by "previous step" means a deep link or a stale sessionStorage
 * cart lands on the step that actually needs the customer, not on step 1.
 */
export function firstIncompleteStep(selection: SelectionState): StepId {
  if (selection.branchId === null) return 'location'
  if (selection.services.length === 0) return 'services'
  if (!selection.slotStart) return 'time'
  return 'details'
}

/** Steps the customer may open given what is already chosen. `done` is only
 *  reachable by actually booking, so it is never granted here. */
export function canEnter(step: StepId, selection: SelectionState): boolean {
  switch (step) {
    case 'location':
      return true
    case 'services':
      return selection.branchId !== null
    case 'specialist':
    case 'time':
      return selection.branchId !== null && selection.services.length > 0
    case 'details':
      return selection.branchId !== null && selection.services.length > 0 && !!selection.slotStart
    case 'done':
      return false
  }
}
